const getOrCreateTooltip = chart => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(1,1,1,0)';
    tooltipEl.style.color = '#2F2F2F';
    tooltipEl.style.borderRadius = '0.625rem';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';

    const table = document.createElement('table');
    table.className = 'rounded-table';
    table.style.margin = '0px';
    table.style.border = 'solid #56821F 0.0625rem';
    table.style.borderColor = '#56821F';
    table.style.background = '#FFFFFF';
    table.style.color = '#2F2F2F';
    table.style.borderStyle = 'solid !important';
    table.style.borderRadius = '0.625rem';
    table.style.borderWidth = '0.0625rem';
    table.style.borderCollapse = 'separate !important';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

// Create a new function using this as a starting point, if you need a different tooltip for a chart.
export const createDateToolTip = context => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  if (tooltip.body) {
    const dataFromCurrentElement = tooltip.dataPoints[0];

    const currentDate = new Date(dataFromCurrentElement.label);
    const percent = dataFromCurrentElement.formattedValue + '%';
    const dateString =
      currentDate.getMonth() +
      1 +
      '/' +
      currentDate.getDate() +
      '/' +
      currentDate.getFullYear();

    // Construct the HTML with centered values
    const innerHtml = `
     <div class="inner-content" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 0.5rem; height: 60px;">
             <div>
                 ${dateString}
             </div>
             <div>
                 ${percent}
             </div>
     </div>
     `;

    tooltipEl.querySelector('table').innerHTML = innerHtml;
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  tooltipEl.style.font =
    'font-family: SF Pro Regular; font-size: 0.75rem; font-weight: 400;';
  tooltipEl.style.padding =
    tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};
